import { render } from "./AssignRoleDataTable.vue?vue&type=template&id=d538acea&scoped=true"
import script from "./AssignRoleDataTable.vue?vue&type=script&lang=js"
export * from "./AssignRoleDataTable.vue?vue&type=script&lang=js"

import "./AssignRoleDataTable.vue?vue&type=style&index=0&id=d538acea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d538acea"]])

export default __exports__